import type { IActionProgressBar } from './actions';
import type { IBannerRules } from './banners';
import type { IGroupFilter } from './filters';
import type { ISsTournamentResponse } from './softswiss/ssTournaments';
import type { IStrapiImage } from './strapiImage';

export interface IMinBet {
  ADA?: string;
  AUD?: string;
  BCH?: string;
  BNB?: string;
  BRL?: string;
  BTC?: string;
  CAD?: string;
  DOG?: string;
  ETH?: string;
  EUR?: string;
  JPY?: string;
  LTC?: string;
  NEO?: string;
  NOK?: string;
  NZD?: string;
  PLN?: string;
  RUB?: string;
  TRX?: string;
  USD?: string;
  USDT?: string;
  XRP?: string;
}

export enum ERaceMechanics {
  Bet = 'Bet',
  Win = 'Win',
  Rate = 'Rate',
  Spin = 'Spin',
  Points = 'Points',
  Special = 'Special',
}

export enum ERaceLabel {
  Weekly = 'Weekly',
  Daily = 'Daily',
  Exclusive = 'Exclusive',
  Partner = 'Partner',
  Event = 'Event',
}

export enum ERaceType {
  Recurring = 'Recurring',
  Custom = 'Custom',
  Network = 'Network',
  SpecialEvent = 'SpecialEvent',
}

export interface IRaceTableItem {
  winner: string;
  prize: string;
  networkCustomSum?: string;
}

export interface IRaceData {
  id: number;
  createdAt: Date;
  updatedAt: Date;
  publishedAt?: Date;
  stageOnly: boolean;
  title: string;
  showGamepage: boolean;
  position: number;
  ssId: string;
  rulesText: string;
  prizeTitle?: string;
  startDate?: Date;
  finishDate?: Date;
  minimumBet?: IMinBet;
  raceMechanics: ERaceMechanics;
  raceLabel: ERaceLabel;
  raceType: ERaceType;
  raceTableCustom: IRaceTableItem[];
  mechanicsNetworkTitle?: string;
  mechanicsNetworkDescriptionText?: string;
  groupFilter?: IGroupFilter;
  bannerCardFront: IStrapiImage;
  bannerCardBack: IStrapiImage;
  progressBar: IActionProgressBar[];
  actionFinaledRound?: boolean;
  locale: string;
  historicalTournamentsId: string;
  providerImage?: IStrapiImage;
  howToParticipateText: string;
}

export interface IRaceStrapiREsponse {
  data: IRaceData[];
}

export enum ERaceStatus {
  active = 'active',
  scheduled = 'scheduled',
  finished = 'finished',
  joined = 'joined',
}

export interface ITournamentWithStatus extends ISsTournamentResponse {
  status: ERaceStatus;
}

export interface ITournamentExtended {
  tournamentData: ITournamentWithStatus;
  raceData: IRaceData;
}

export interface IRacesBannerData {
  id: number;
  createdAt: Date;
  updatedAt: Date;
  publishedAt?: Date;
  subtitleFirst: string;
  subtitleSecond: string;
  buttonTitle: string;
  bannerCardFront: IStrapiImage;
  bannerCardBack: IStrapiImage;
  bannerRules?: IBannerRules[];
  bannerAction: any;
  locale: string;
}

export interface IRacesBannerStrapiResponse {
  data: IRacesBannerData[];
}
